import useFormatPrice from '../components/composables/useFormatPrice'

document.addEventListener('DOMContentLoaded', function () {
    const { formatPrice } = useFormatPrice()

    function formatStorage(value) {
        return value >= 1000 ? (value / 1000).toFixed(1) + ' TB' : value + ' GB'
    }

    const sliderContent = document.getElementById('slider-content')

    // Constants
    const LANGUAGE = String(sliderContent.dataset.language)
    const CURRENCY = String(sliderContent.dataset.currency)
    const BASE_PRICE = parseFloat(sliderContent.dataset.basePrice)
    const STORAGE_MIN = parseInt(sliderContent.dataset.storageMin)
    const BANDWIDTH_MIN = parseInt(sliderContent.dataset.bandwidthMin)
    const STORAGE_RATE = parseFloat(sliderContent.dataset.storageRate)
    const BANDWIDTH_RATE = parseFloat(sliderContent.dataset.bandwidthRate)

    // DOM Elements
    const storageSlider = sliderContent.querySelector('#storage-slider')
    const bandwidthSlider = sliderContent.querySelector('#bandwidth-slider')
    const totalPrice = sliderContent.querySelector('.total-price')
    const storageAmount = sliderContent.querySelector('[data-value="storage-amount"]')
    const bandwidthAmount = sliderContent.querySelector('[data-value="bandwidth-amount"]')
    const storageInput = sliderContent.querySelector('#storage-input')
    const bandwidthInput = sliderContent.querySelector('#bandwidth-input')
    const storageMinLabel = sliderContent.querySelector('[data-value="storage-minimum"]')
    const storageMaxLabel = sliderContent.querySelector('[data-value="storage-maximum"]')
    const bandwidthMinLabel = sliderContent.querySelector('[data-value="bandwidth-minimum"]')
    const bandwidthMaxLabel = sliderContent.querySelector('[data-value="bandwidth-maximum"]')

    // Calculate total price
    function calculatePrice() {
        const storageGB = parseInt(storageSlider.value)
        const bandwidthGB = parseInt(bandwidthSlider.value)

        // Calculate additional costs
        const additionalStoragePrice = (storageGB - STORAGE_MIN) * STORAGE_RATE
        const additionalBandwidthPrice = (bandwidthGB - BANDWIDTH_MIN) * BANDWIDTH_RATE

        // Update UI
        totalPrice.textContent = formatPrice(
            Number(BASE_PRICE + additionalStoragePrice + additionalBandwidthPrice).toFixed(2),
            CURRENCY,
            LANGUAGE
        )
        storageAmount.textContent = formatStorage(storageGB)
        bandwidthAmount.textContent = formatStorage(bandwidthGB)
    }

    // Synchronize sliders and inputs
    function syncSliderWithInput(slider, input) {
        let value = parseInt(input.value)
        const min = parseInt(slider.min)
        const max = parseInt(slider.max)

        if (isNaN(value)) {
            value = min
        } else if (value < min) {
            value = min
        } else if (value > max) {
            value = max
        }

        slider.value = value
        calculatePrice()
    }

    // Initialize sliders and inputs
    function initializeSliders() {
        // Reset sliders and inputs to their base values
        storageSlider.value = STORAGE_MIN
        bandwidthSlider.value = BANDWIDTH_MIN
        storageInput.value = STORAGE_MIN
        bandwidthInput.value = BANDWIDTH_MIN

        // Populate min and max labels for storage and bandwidth sliders
        storageMinLabel.textContent = formatStorage(parseInt(storageSlider.min))
        storageMaxLabel.textContent = formatStorage(parseInt(storageSlider.max))
        bandwidthMinLabel.textContent = formatStorage(parseInt(bandwidthSlider.min))
        bandwidthMaxLabel.textContent = formatStorage(parseInt(bandwidthSlider.max))

        // Update the display to reflect the base values
        calculatePrice()

        // Add event listeners for sliders
        storageSlider.addEventListener('input', () => {
            storageInput.value = storageSlider.value
            calculatePrice()
        })

        bandwidthSlider.addEventListener('input', () => {
            bandwidthInput.value = bandwidthSlider.value
            calculatePrice()
        })

        // Add event listeners for text inputs
        storageInput.addEventListener('input', () => {
            syncSliderWithInput(storageSlider, storageInput)
        })

        bandwidthInput.addEventListener('input', () => {
            syncSliderWithInput(bandwidthSlider, bandwidthInput)
        })
    }

    // Initialize everything
    initializeSliders()
})
